import viTranslation from "./vi/translation.json";
import enTranslation from "./en/translation.json";

export default {
  vi: {
    translation: viTranslation,
  },
  en: {
    translation: enTranslation,
  },
};
